export enum InspectionStatus {
  TO_PLAN = 'TO_PLAN',
  PLANNED = 'PLANNED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUBMITTED = 'SUBMITTED',
  REVIEWED = 'REVIEWED',
  APPROVED = 'APPROVED',
  UNDER_REVIEW = 'UNDER_REVIEW', // Inspection already submitted revision
  NEEDS_REVISIONS = 'NEEDS_REVISIONS', // Inspection already request revision
}
export const SECTION_TYPE_CUSTOM_SECTION = 'CUSTOM_SECTION' as const
export const SECTION_TYPE_WEIGHT_SECTION = 'WEIGHT_SECTION' as const
export const SECTION_TYPE_MEASUREMENT_SECTION = 'MEASUREMENT_SECTION' as const
export const SECTION_TYPE_WORKMANSHIP_SECTION = 'WORKMANSHIP_SECTION' as const

export enum InspectionResult {
  PASS = 'PASS',
  FAIL = 'FAIL',
  NA = 'N/A',
  PENDING = 'PENDING',
}

export const DEFAULT_OVERALL_RESULT = [
  {
    name: 'pass',
    color: '#65BF73',
    value: 'PASS',
    locked: true,
    selected: true,
    display_order_web: 0,
    display_order_mobile: 3,
  },
  {
    name: 'fail',
    color: '#C03261',
    value: 'FAIL',
    locked: true,
    selected: true,
    display_order_web: 1,
    display_order_mobile: 2,
  },
  {
    name: 'pending',
    color: '#EF9747',
    value: 'PENDING',
    locked: false,
    selected: true,
    display_order_web: 2,
    display_order_mobile: 1,
  },
  {
    name: 'na',
    color: '#848484',
    value: 'N/A',
    locked: false,
    selected: true,
    display_order_web: 3,
    display_order_mobile: 0,
  },
]

export type InspectionStatusType = keyof typeof InspectionStatus

export type InspectionResultType = keyof typeof InspectionResult

export enum InspectionGroupStatus {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
}

export enum InspectionReportSectionEnum {
  CHECKPOINT = 'CHECKPOINT',
  DEFECT = 'DEFECT',
}

export enum InspectionTemplateType {
  TJX_PRE_PRODUCTION_SAMPLE = 'TJX_PRE_PRODUCTION_SAMPLE',
  TJX_FINAL = 'TJX_FINAL',
  KINGTEX_CUSTOM = 'KINGTEX_CUSTOM',
  GDS_FABRIC = 'GDS_FABRIC',
  FCCA = 'FCCA',
}
export type INSPECTION_PARAMS_TYPE = {
  page_number?: number
  page_size?: number
  group?: 'ACTIVE' | 'COMPLETED' | string
}

export type INSPECTION_PAYLOAD_TYPE = {
  query?: string | null
  status?: (InspectionStatusType | string)[] | null
  result?: (InspectionResultType | string)[] | null
  inspectors?: string[] | null
  planned_date?: any
  style_ids?: string[] | null
  brands?: string[] | null
  submitted_date?: any
  suppliers?: string[] | null
  factories?: string[] | null
  countries?: string[] | null
  inspection_type_ids?: string[] | null
  order_ids?: string[] | null
}

/**
 * Advance filter sorting
 */
export const INSPECTION_ADVANCE_FILTER_LISTING: (keyof INSPECTION_PAYLOAD_TYPE)[] =
  [
    'query',
    'planned_date',
    'submitted_date',
    'order_ids',
    'style_ids',
    'brands',
    'suppliers',
    'factories',
    'countries',
    'inspection_type_ids',
    'inspectors',
    'result',
    'status',
  ]

export const UPDATE_TYPE = {
  INSPECTION_SUBMIT: 'inspection_submit',
  INSPECTION_APPROVE: 'inspection_approve',
  INSPECTION_DELETE_APPROVED: 'inspection_delete_approved',
  INSPECTION_UNLOCK_APPROVED: 'inspection_unlock_approved',
  INSPECTION_RESULT_UPDATE: 'inspection_result_update',
  INSPECTION_DECISION_UPDATE: 'inspection_decision_update',
  INSPECTION_DEFECT_UPDATE: 'inspection_defect_update',
  INSPECTION_DEFECT_DELETE: 'inspection_defect_delete',
  INSPECTION_DEFECT_PHOTO_ADD: 'inspection_defect_photo_add',
  INSPECTION_DEFECT_PHOTO_COMMENT: 'inspection_defect_photo_comment',
  INSPECTION_DEFECT_PHOTO_DELETE: 'inspection_defect_photo_delete',
  INSPECTION_CHECKPOINT_PHOTO_COMMENT: 'inspection_checkpoint_photo_comment',
  INSPECTION_CHECKPOINT_GROUP_ENTRY_UPDATE_PHOTO_COMMENT:
    'inspection_checkpoint_group_entry_update_photo_comment',
  INSPECTION_CHECKPOINT_DELETE_GROUP_ENTRY_UPDATE_PHOTO_COMMENT:
    'inspection_checkpoint_delete_group_entry_photo_comment',
  INSPECTION_CHECKPOINT_ADD_GROUP_ENTRY_UPDATE_PHOTO_COMMENT:
    'inspection_checkpoint_add_group_entry_photo_comment',
  INSPECTION_CHECKPOINT_UPDATE_GROUP_ENTRY: 'inspection_update_group_entry',
  INSPECTION_CHECKPOINT_SELECT: 'inspection_checkpoint_select',
  INSPECTION_CHECKPOINT_TEXT: 'inspection_checkpoint_text',
  INSPECTION_CHECKPOINT_MULTI_SELECT: 'inspection_checkpoint_multi_select',
  INSPECTION_CHECKPOINT_NUMBER: 'inspection_checkpoint_number',
  INSPECTION_CHECKPOINT_DATE: 'inspection_checkpoint_date',
  INSPECTION_CHECKPOINT_EDITABLE_CHOICE:
    'inspection_checkpoint_editable_choice',
  INSPECTION_CHECKPOINT_DELETE_PHOTO_COMMENT:
    'inspection_checkpoint_delete_photo_comment',
  INSPECTION_CHECKPOINT_ADD_PHOTO_COMMENT:
    'inspection_checkpoint_add_photo_comment',
  INSPECTION_SECTION_UPDATE: 'inspection_section_update',
}

export const INSPECTION_COMMENT_SECTION = 'inspection_comment_section'
export const INSPECTION_COMMENT_CHECKPOINT = 'inspection_comment_checkpoint'
export const INSPECTION_COMMENT_NEEDS_REVISIONS =
  'inspection_comment_needs_revisions'
export const INSPECTION_COMMENT_UNDER_REVIEW = 'inspection_comment_under_review'

export const INSPECTION_COMMENT_SAMPLE_APPROVED =
  'inspection_comment_sample_approved' as const
export const INSPECTION_COMMENT_INSPECTION_SUMMARY =
  'inspection_comment_inspection_summary' as const
export const INSPECTION_COMMENT_OVERALL = 'inspection_comment_overall' as const

export const historyLogDrawer = {
  defectPhotoDelete: 'deleted a photo / comment in',
  defectPhotoAdd: 'added a photo / comment in',
  defectPhotoComment: 'edited a photo / comment in',
}

export const DESIRED_ORDER_LOG = ['photo', 'comment']
export const MEASUREMENT_SPECIAL_SEPARATOR_KEY = '~*|*|*~'

export const QSF_QUERY_KEY = {
  GET_COMPANY_SETTING_SECTION_GROUP: 'GET_COMPANY_SETTING_SECTION_GROUP',
  GET_COMPANY_SETTING_INSPECTION_OVERALL_RESULT:
    'GET_COMPANY_SETTING_INSPECTION_OVERALL_RESULT',
}
